module.exports = __webpack_public_path__ + "images/emoji/purse.ff86071f909efd7aba1c.png";